// src/pages/PlansPage.js
import React, { useState, useContext } from "react";
import BuyerPlansModal from "../Components/Plans/BuyerPlansModal";
import SellerPlansModal from "../Components/Plans/SellerPlansModal";
import { AuthContext } from "../contextStore/AuthContext";

export default function PlansPage() {
  const { user } = useContext(AuthContext);
  const [open, setOpen] = useState(true);

  const isSeller = !!(user && user.role && String(user.role).toLowerCase().includes("seller"));

  function handleClose() {
    setOpen(false);
  }

  function handlePurchased(payload) {
    // payload: { type, planId, paymentId, listingId }
    alert("Plan purchased successfully.");
    // optionally refresh user profile or re-fetch subscriptions
  }

  return (
    <div style={{ padding: 16 }}>
      <h2>Plans</h2>
      <p>
        Choose a plan for {isSeller ? "selling" : "buying"}.
      </p>

      {isSeller ? (
        <SellerPlansModal
          open={open}
          onClose={handleClose}
          onPurchased={handlePurchased}
        />
      ) : (
        <BuyerPlansModal
          open={open}
          onClose={handleClose}
          onPurchased={handlePurchased}
        />
      )}

      {!open && (
        <div>
          <button onClick={() => setOpen(true)}>Open plans</button>
        </div>
      )}
    </div>
  );
}
